// Hooks for BetterDocs support documentation
import { useQuery } from '@tanstack/react-query';
import { docsService, DocsPost, DocsCategory } from '@/services/docsService';

export const useDocsPosts = (params: {
  page?: number;
  per_page?: number;
  search?: string;
  doc_category?: string;
  orderby?: string;
  order?: 'asc' | 'desc';
} = {}) => {
  return useQuery({
    queryKey: ['docs-posts', params],
    queryFn: () => docsService.fetchPosts(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useDocsCategories = () => {
  return useQuery({
    queryKey: ['docs-categories'],
    queryFn: () => docsService.fetchCategories(),
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export const useDocsFeaturedImage = (post: DocsPost | undefined) => {
  return useQuery({
    queryKey: ['docs-featured-image', post?.featured_media],
    queryFn: () => post ? docsService.getFeaturedImageUrl(post) : null,
    enabled: !!(post?.featured_media),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};